import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import { createStore, applyMiddleware, compose } from "redux";

import conductorReducer from "./reducers";

const loggerMiddleware = createLogger();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  conductorReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware))
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js